var Type = require("./Type");

/**
 * The Enumeration class represents an enumeration data type.
 * The Enumeration allows to assign particular values for
 * corresponding keys.
 *
 * @param {Object} [oConfig] Configuration object for this type
 * @param {Object} [oData.valueMap] Contains a JS object or Map with key value pairs
 * @constructor
 */
function Enumeration(oConfig) {
	Type.call(this, oConfig);

	this._valueMap = oConfig && oConfig.valueMap ? oConfig.valueMap : {};
}

Enumeration.prototype = Object.create(Type.prototype);
Enumeration.prototype.constructor = Enumeration;

/**
 * Returns the mapped value for the key that is present in the
 * business object.
 *
 * @param {string} sProperty Name of the property that contains the key
 * @param {Object} oData Business object that contains the data
 * @returns {string} The value of the given property after type specific processing
 * @protected
 */
Enumeration.prototype.getValue = function(sProperty, oData) {
	var key, result;

	key = oData[sProperty];
	result = this._valueMap instanceof Map ? this._valueMap.get(key) : this._valueMap[key];

	return result || "";
};

module.exports = Enumeration;